"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFirstIteratorResult = getFirstIteratorResult;
function getFirstIteratorResult(iterator) {
    if (iterator === undefined) {
        return undefined;
    }
    const firstIteratorResult = iterator.next();
    if (firstIteratorResult.done === true) {
        return undefined;
    }
    return firstIteratorResult.value;
}
//# sourceMappingURL=getFirstIteratorResult.js.map